import React from "react";
import * as PropTypes from "prop-types";
import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@mui/styles";
import WorxFormContainer from "../../../Container/Forms/Generic/WorxFormContainer";

const topCardUseStyles = makeStyles({
  root: {
    marginBottom: "2em",
  },
});

const JuniorAnalystSurveyFormDisplay = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { title, mapOverride, disabledMap, hideMap, formik } = props;

  const topCardClasses = topCardUseStyles();

  return (
    <React.Fragment>
      <Card classes={{ root: topCardClasses.root }}>
        <CardContent>
          <h3>{title}</h3>
          <WorxFormContainer
            mapOverride={mapOverride}
            disabledMap={disabledMap}
            hideMap={hideMap}
            formik={formik}
          />
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

JuniorAnalystSurveyFormDisplay.propTypes = {
  title: PropTypes.string.isRequired,
  mapOverride: PropTypes.object.isRequired,
  disabledMap: PropTypes.object.isRequired,
  hideMap: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired,
};

export default JuniorAnalystSurveyFormDisplay;
